import fetch from 'cross-fetch';
import { validateResponse } from './ApiCommon';
import { GET_REQUEST } from './ApiConstants';
// #if process.env.BUILD_SECURE === '1'
// import { CannyTokenURL } from './ApiUrls';
// #endif

export const getCannyToken = async () => {
    try {
        const response = await fetch(`${CannyTokenURL}`, GET_REQUEST).then(
            validateResponse
        );

        if (!response.success || !response.sso_token) {
            throw new Error('CannyApi: Failed to fetch SSO token');
        }

        return response.sso_token;
    } catch (error) {
        throw error;
    }
};
